import type { FilterWithDisabledState } from '../../filters/components/FilterTags';
import { useRemoveFilter } from '../../filters/contexts/FilterProvider';
import { useEffectiveFilters } from '../../filters/hooks/useEffectiveFilters';
import type { UnpackedFilter } from '../../filters/hooks/useMultiFilterEditor';
import { type FilterId, isMultiFilter } from '../../filters/types/filters';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';

export const useFilterTags = (): {
  filterTags: FilterWithDisabledState[];
  onRemoveFilter: (filterId: FilterId) => void;
} => {
  const effectiveFilters = useEffectiveFilters({
    includeDisabledFilters: true,
  });
  const onRemoveFilter = useRemoveFilter();
  const { hasSecondaryFilter } = useTabContentConfig();

  // Unset filters are not visible. Unpack multi filters into their instances.
  const visibleFilters: UnpackedFilter[] = effectiveFilters
    .flatMap((filter) => {
      if (isMultiFilter(filter)) {
        return filter.instances.map((instance, index) => ({
          ...instance,
          displayId: `${filter.id}_instance_${index}`,
          parentMultiFilterId: filter.id,
          instanceIndex: index,
        }));
      }
      return [filter];
    })
    .filter((filter) => filter.isVisible && !filter.isPrimary);

  const filterTags: FilterWithDisabledState[] = visibleFilters.map((filter) => {
    const isMultiInstance = filter.parentMultiFilterId !== undefined;
    return {
      filter,
      disabled: isMultiInstance ? false : !hasSecondaryFilter(filter.id),
    };
  });

  return { filterTags, onRemoveFilter };
};
